import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Barcode from 'react-barcode';
import withSizes from 'react-sizes';
import isEmpty from 'lodash/isEmpty';

const BARCODE_LINE_COUNT = 11;
const BARCODE_DEFAULT_COUNT = 35;
const BARCODE_HEIGHT_RATIO = 4.77;

class BarcodeWrapper extends Component {

  renderEmpty() {
    return (
      <div className="img_g">
      </div>
    );
  }

  render() {
    const { value, maxWidth, marginWidth, format, displayWidth } = this.props;
    const barcodeWidth = Math.min(maxWidth, displayWidth - marginWidth);
    if (isEmpty(value)) {
      return this.renderEmpty();
    }
    const valueLength = value.length;
    let barWidth;
    if (format === 'CODE128C') {
      barWidth = parseFloat((barcodeWidth / ((Math.ceil(valueLength / 2) * BARCODE_LINE_COUNT) + BARCODE_DEFAULT_COUNT)).toFixed(2));
    } else if (format === 'CODE128A' || format === 'CODE128B') {
      barWidth = parseFloat((barcodeWidth / ((valueLength * BARCODE_LINE_COUNT) + BARCODE_DEFAULT_COUNT)).toFixed(2));
    } else {
      return this.renderEmpty();
    }
    const barcodeHeight = parseFloat((barcodeWidth / BARCODE_HEIGHT_RATIO).toFixed(4));

    return (
      <div className="img_g" style={{ height: barcodeHeight }}>
        <Barcode
          value={value}
          width={barWidth}
          height={barcodeHeight}
          background="#FFFFFF"
          format={format}
          displayValue={Boolean(false)}
          margin={0}
        />
      </div>
    );
  }
}

BarcodeWrapper.propTypes = {
  value: PropTypes.string.isRequired,
  format: PropTypes.string,
  maxWidth: PropTypes.number,
  marginWidth: PropTypes.number,
  displayWidth: PropTypes.number
};

BarcodeWrapper.defaultProps = {
  format: 'CODE128C',
  maxWidth: 280,
  marginWidth: 94,
  displayWidth: 375
};

const mapSizesToProps = ({ width, height }) => {
  if (width === null || height === null) {
    return { displayWidth: 375 };
  }
  return { displayWidth: width };
};

export default withSizes(mapSizesToProps)(BarcodeWrapper);


// WEBPACK FOOTER //
// ./src/components/Membership/Barcode.js